export default "__VITE_ASSET__Cl8Ko3Hi__"